import React, { useState, useEffect } from "react";
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Button,
    Dialog,
    DialogTitle,
    DialogActions,
    DialogContent,
    DialogContentText,
    Divider,
    TextField,
    FormControl
} from "@material-ui/core";
import { connect } from "react-redux";
import Autocomplete from '@material-ui/lab/Autocomplete';
import { setLoading, setSnackInfo } from "../../redux/actions/appAction";
import { DownloadOutlined, EyeOutlined } from "@ant-design/icons";
import { Modal } from "antd";
import { makeStyles, useTheme, withStyles } from "@material-ui/core/styles";
import moment from "moment";
import HttpService from "../../services/httpService";
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import { palette } from "@mui/system";

const useStyles = makeStyles((theme) => ({
    table: {
        minWidth: 850,
    },
    textField: {
        width: 100,
    },
    paper: {
        padding: theme.spacing(2),
        margin: "auto",
        maxWidth: 400,
    },
}));

const StyledTableCell = withStyles((theme) => ({
    head: {
        backgroundColor: "#1C375D",
        color: '#FFF2EB',
        fontWeight: "500",
        // border: '1px solid black'
    },
    body: {
        fontSize: 14,
        // border: '1px solid red'
    },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
    root: {
        "&:nth-of-type(odd)": {
            backgroundColor: theme.palette.action.hover,
        },
    },
}))(TableRow);

const RejectedInwarding = (props) => {
    const classes = useStyles();
    const [dataForPendingInwardingApproval, setDataForPendingInwardingApproval] = useState([]);
    const [selectedOrderId, setSelectedOrderId] = useState("");
    const [openRemarksModal, setOpenRemarksModal] = useState(false);
    const [remarks, setRemarks] = useState("");
    const [details, setDetails] = useState([]);
    const [textContent, setTextContent] = useState("");
    const [procurementDetails, setProcurementDetails] = useState({});
    const [invoiceModal, setInvoiceModal] = useState(false);
    const [value, setValue] = useState("");
    const [freightCharge, setFreightCharge] = useState(0);
    const [gstAmounts, setGstAmounts] = useState(0);
    const [materialOriginalPrice, setMaterialOriginalPrice] = useState([]);
    const [material, setMaterial] = useState({});
    const [transportationCharge, setTransportationCharge] = useState(0);
    const [openRejectionConfirmationDialog, setOpenRejectionConfirmationDialog] = useState(false);
    // const [editableFields, setEditableFields] = useState({
    //     transportationCharge: transportationCharge,
    //     gstAmounts: gstAmounts,
    //     freightCharge: freightCharge,
    // });
    const [updatedMat, setUpdatedMat] = useState(0);
    const [gstOrginalAmount, setGstOriginalAmount] = useState(0);
    // const [isGstUpdated, setIsGstUpdated] = useState(false);
    const [isMaterialUpdated, setIsMaterialUpdated] = useState(false);
    const [editFields, setEditFields] = useState(false);
    const [gstDetails, setGstDetails] = useState({ type: "", rate: "" });
    const [fileUploaded, setFileUploaded] = useState(false);
    const [newInvoiceDetails, setNewInvoiceDetails] = useState({
        invoiceNumber: "",
        invoiceDate: "",
        invoiceLink: "",
        remarks: "",
    })
    const gstPercent = ["5", "12", "18", "28"];


    // function to get Rejected Inwardings data
    const getFinanceRejectedInwardingData = async () => {
        props.setLoading(true);
        try {
            const response = await HttpService.getInwardingApprovalDataRejectedByFincance();
            setDataForPendingInwardingApproval(response.data);
            // setDataToDisplay(response.data);
        } catch (err) {
            props.setSnackInfo(
                err?.response?.data ?? "Something went wrong",
                "error"
            );
        }
        props.setLoading(false);
    };

    // Function to Open Remarks Modal
    const openResolveModalHandler = (status) => {
        // if (status === "Approved") {
        //     setTextContent("Approval");
        // }
        // if (status === "Rejected") {
        //     setTextContent("Rejection");
        // }
        setValue(status);
        setOpenRemarksModal(true);
    };

    // Funtion to close Remarks Modal
    const closeNewInvoiceDetailsModalHandler = () => {
        setOpenRemarksModal(false);
        setFileUploaded(false);
        setNewInvoiceDetails({
            invoiceNumber: "",
            invoiceDate: "",
            invoiceLink: "",
            remarks: "",
        });
        setRemarks("");
    };

    // Funtion to get type of the file do display
    const getFileType = (url) => {
        const extension = url?.split(".").pop()?.toLowerCase();
        if (extension === "pdf") {
            return "pdf";
        } else if (
            extension === "jpg" ||
            extension === "jpeg" ||
            extension === "png" ||
            extension === "gif"
        ) {
            return "image";
        } else {
            return "unknown";
        }
    };

    // Function to open invoice Modal
    const openInwardingDetailModalHelper = (materialId, data, value) => {
        setInvoiceModal(true);
        priceCal(materialId, data, value);
        setMaterial(
            procurementDetails?.materials?.filter(
                (material) => material?.materialId?._id === materialId
            )[0]
        );
        // setIndex(i)
    };

    // A helper function to calculate the necessary fields when rate, gst, freight, or transportation charges are changed
    const priceCal = (materialId, data, value) => {
        let total = 0;
        let subTotal = 0;
        let presicionDiff = 0;
        let toatlGstAmount = 0;
        let totalQty = 0;
        data.materials.forEach((mat) => {
            if (
                mat.materialId._id.toString() === materialId.toString() &&
                mat?.materialId?._id?.toString() ===
                value?.materialIdOfInwarding?._id?.toString()
            ) {
                // mat.materialTotal = +mat.requestedQuantity * +mat.requestedPrice || +mat.materialId.pricePerUnit;
                mat.materialTotal =
                    +value?.InwardingRecords?.inwardedQty * +value?.InwardingRecords?.inwardedRate ||
                    +mat.materialId.pricePerUnit;
                total += +mat.materialTotal;
                // totalQty += mat.requestedQuantity;
                totalQty += +value?.InwardingRecords?.inwardedQty;
                mat.isAdded = true;
            }
        });

        if (data.discount) {
            // total = total - data.discount;
            let discountAmount = (data.discount / 100) * +total; // Calculate the discount amount
            total -= discountAmount;
        } else {
            data.discount = 0;
        }
        subTotal = +total;

        if (data.gstRequired) {
            data.gstDetails.forEach((gstDetail) => {
                gstDetail.gstAmount = Number(
                    Number.parseFloat((gstDetail.rate * total) / 100).toFixed(2)
                );
                toatlGstAmount += gstDetail.gstAmount;
            });
            total = +total + +toatlGstAmount;
        } else {
            toatlGstAmount = 0;
        }

        if (value.InwardingRecords.freightCharge) {
            total = total + +value.InwardingRecords.freightCharge;
        } else {
            data.freight = 0;
        }

        if (data.transportationCharge) {
            total = +total + +data.transportationCharge;
        } else {
            data.transportationCharge = 0;
        }

        data.totalQty = +totalQty;
        data.subTotal = +subTotal;
        data.grandTotal = +total;
        // data.freight = +freightCharge;
        presicionDiff =
            Math.round(total) -
            Number(Number.parseFloat(subTotal).toFixed(2)) -
            Number(Number.parseFloat(toatlGstAmount).toFixed(2)) +
            Number(Number.parseFloat(data.discount).toFixed(2)) -
            Number(Number.parseFloat(data.transportationCharge).toFixed(2)) -
            Number(Number.parseFloat(data.freight).toFixed(2));
        data.presicionDiff = Number.parseFloat(presicionDiff).toFixed(2);
        // let word = numWords(Math.round(+procurementDetails.grandTotal));
        // procurementDetails.amountInWords = word.toUpperCase();
        setTransportationCharge(+data?.transportationCharge);
        setFreightCharge(value?.InwardingRecords?.freightCharge || 0);
        setGstAmounts(+toatlGstAmount);
        // setEditableFields({ ...editableFields, gstAmounts: data?.gstDetails });
        setUpdatedMat(data.grandTotal);
        setProcurementDetails(data);
        return data;
    };

    // Function to get procurement Details based on the click on action button
    const openInwardingDetailModalHandler = async (value) => {
        setSelectedOrderId(value?.procurementId?.orderId);
        // setValue(value);
        setDetails(value);
        props.setLoading(true);
        try {
            const result = await HttpService.getProcurementByOrderIdForInwarding(
                value?.procurementId?.orderId
            );
            let arr = result?.data?.materials?.map((el) => el.requestedPrice);

            // setOpenDialog(true)
            openInwardingDetailModalHelper(
                value?.materialIdOfInwarding?._id,
                result.data,
                value
            );
            setMaterialOriginalPrice(arr);
            setFreightCharge(value?.InwardingRecords?.freightCharge || 0);
            setGstDetails({ type: result.data?.gstDetails[0]?.gst, rate: result.data?.gstDetails[0]?.rate });
            setProcurementDetails(result.data);
        } catch (error) {
            console.error(error);
            // props.setSnackInfo(error?.response?.data ?? "Something went wrong", "error")
        }
        props.setLoading(false);
    };

    // Function to resolve Finance Rejected Inwarding
    const resolveRejectedInwardingHandler = async () => {
        props.setLoading(true);
        if (newInvoiceDetails.remarks.trim().length === 0) {
            // props.setSnackInfo("Please enter remarks before submitting.", "warning");
            props.setSnackInfo(`Please Enter ${textContent} Remarks`, "warning");
            props.setLoading(false);
            return;
        }
        let payload = { status: value, newInvoiceDetails, inwardingDetails: details, remarks: newInvoiceDetails.remarks };

        try {
            const response = await HttpService.updateRejectedInwardingStatus(payload);
            props.setSnackInfo(response?.data?.msg ?? "Updated Successfully", response?.data?.type ?? "success");
            // props.setSnackInfo("Updated Successfully From the frontend", "success");
        } catch (err) {
            console.error("Error -> ", err);
            props.setSnackInfo(
                err?.response?.data?.msg ?? "Something went wrong",
                err?.response?.type ?? "error"
            );
        }
        setOpenRemarksModal(false);
        setRemarks("");
        setInvoiceModal(false);
        setFileUploaded(false);
        setNewInvoiceDetails({
            invoiceNumber: "",
            invoiceDate: "",
            invoiceLink: "",
            remarks: "",
        });
        props.setLoading(false);
        getFinanceRejectedInwardingData();
    }

    // function to handle price change of material
    const materialPriceChangeHandler = (index, event) => {
        // Log the index and the new value

        // Set isMaterialUpdated to true
        setIsMaterialUpdated(true);

        // Create a copy of procurementDetails
        const updatedProcurementDetails = { ...procurementDetails };
        // Update the requested price for the material at the specified index
        updatedProcurementDetails.materials[index].requestedPrice =
            +event.target.value;

        // Initialize variables for calculations
        let total = 0;
        let subTotal = 0;
        let presicionDiff = 0;
        let toatlGstAmount = 0;
        let totalQty = 0;


        // Calculate total and total quantity for all materials
        updatedProcurementDetails.materials.forEach((mat, i) => {
            if (mat.isAdded === true) {
                // mat.materialTotal = +mat.requestedQuantity * +mat.requestedPrice || +mat.materialId.pricePerUnit;
                mat.materialTotal =
                    +details?.InwardingRecords?.inwardedQty * +event.target.value ||
                    +details?.InwardingRecords?.inwardedRate;
                total += +mat.materialTotal;
                // totalQty += mat.requestedQuantity;
                totalQty += details?.InwardingRecords?.inwardedQty;
            }
        });



        // Calculate subTotal
        if (updatedProcurementDetails.discount) {
            // total = total - updatedProcurementDetails.discount;
            let discountAmount = (updatedProcurementDetails.discount / 100) * total; // Calculate the discount amount
            total -= discountAmount;
        } else {
            updatedProcurementDetails.discount = 0;
        }
        subTotal = +total;

        // Calculate GST amounts
        if (updatedProcurementDetails.gstRequired) {
            updatedProcurementDetails.gstDetails.forEach((gstDetail) => {
                gstDetail.gstAmount = Number(
                    Number.parseFloat((gstDetail.rate * total) / 100).toFixed(2)
                );
                toatlGstAmount += +gstDetail.gstAmount;
            });
            total = +total + +toatlGstAmount;
        } else {
            toatlGstAmount = 0;
        }

        // Calculate total with freight
        if (details.InwardingRecords.freightCharge) {
            total = total + details.InwardingRecords.freightCharge
        } else {
            updatedProcurementDetails.freight = 0;
        }

        // Calculate total with transportation charge
        if (updatedProcurementDetails.transportationCharge) {
            total = +total + +updatedProcurementDetails.transportationCharge;
        } else {
            updatedProcurementDetails.transportationCharge = 0;
        }

        // Update procurementDetails with calculated values
        updatedProcurementDetails.totalQty = +totalQty;
        updatedProcurementDetails.subTotal = +subTotal;
        updatedProcurementDetails.grandTotal = +total;
        updatedProcurementDetails.freight = +freightCharge;
        presicionDiff =
            Math.round(total) -
            Number(Number.parseFloat(subTotal).toFixed(2)) -
            Number(Number.parseFloat(toatlGstAmount).toFixed(2)) +
            Number(Number.parseFloat(updatedProcurementDetails.discount).toFixed(2)) -
            Number(
                Number.parseFloat(
                    updatedProcurementDetails.transportationCharge
                ).toFixed(2)
            ) -
            Number(Number.parseFloat(updatedProcurementDetails.freight).toFixed(2));
        updatedProcurementDetails.presicionDiff =
            Number.parseFloat(presicionDiff).toFixed(2);
        
        // Update state with new values
        setTransportationCharge(updatedProcurementDetails?.transportationCharge);
        setFreightCharge(value?.InwardingRecords?.freightCharge || +freightCharge);
        setGstAmounts(toatlGstAmount);
        setGstOriginalAmount(toatlGstAmount);
        // setEditableFields({
        //     ...editableFields,
        //     gstAmounts: updatedProcurementDetails?.gstDetails,
        // });
        setUpdatedMat(updatedProcurementDetails.grandTotal);

        // Update the requested price for the material at Inwarding approvals
        setDetails((prevState) => ({
            ...prevState,
            InwardingRecords: {
                ...prevState.InwardingRecords,
                inwardedRate: event.target.value
            }
        }));

        // updating the procurementDetails
        setProcurementDetails(updatedProcurementDetails);

        // Return the updated procurementDetails
        // return updatedProcurementDetails;
    };

    // function to handle change in freight charges
    const freightChargeChangeHandler = (event) => {
        const procurementObj = { ...procurementDetails };
        setFreightCharge(+event.target.value);
        procurementObj.freight = +event.target.value;
        procurementObj.grandTotal = +procurementObj.grandTotal - +freightCharge + +event.target.value;
        const detailObj = { ...details };
        details.InwardingRecords.freightCharge = +event.target.value;
        setProcurementDetails(procurementObj);
        setDetails(detailObj);
        // setEditableFields({
        //     ...editableFields,
        //     freightCharge: +event.target.value,
        // });
    };

    // Function to handle remarks input
    const newInvoiceDetailsHandler = async (event) => {
        if (event.target.name === "new-invoice-number") {
            setNewInvoiceDetails({ ...newInvoiceDetails, invoiceNumber: event.target.value });
        }
        if (event.target.name === "new-invoice-date") {
            setNewInvoiceDetails({ ...newInvoiceDetails, invoiceDate: event.target.value });
        }
        if (event.target.name === "remarks") {
            setNewInvoiceDetails({ ...newInvoiceDetails, remarks: event.target.value });
        }
        // setRemarks(e.target.value);
    };

    // Function to handle the change in GST Rates
    const gstRateChangeHandler = (event, value) => {
        setGstDetails({ ...gstDetails, rate: value });
        const procurementObj = { ...procurementDetails };
        procurementDetails.gstDetails[0].rate = value;
        priceCal(details.materialIdOfInwarding._id, procurementDetails, details);
        // setProcurementDetails(procurementObj);
    }

    // Function to reject the Inwarding Overall From Factory
    const rejectInwardingFromFactory = async () => {
        props.setLoading(true);
        if (remarks.trim().length === 0) {
            props.setSnackInfo("Please Enter Remarks", "error");
            props.setLoading(false);
            return;
        }
        let payload = { status: value, inwardingDetails: details, remarks: remarks };

        try {
            const response = await HttpService.updateRejectedInwardingStatus(payload);
            window.open(response.data.newGrnLink);
            props.setSnackInfo(response?.data?.msg ?? "Updated Successfully", response?.data?.type ?? "success");
            // props.setSnackInfo("Updated Successfully From the frontend", "success");
        } catch (err) {
            console.error("Error -> ", err);
            props.setSnackInfo(
                err?.response?.data?.msg ?? "Something went wrong",
                err?.response?.type ?? "error"
            );
        }

        setOpenRejectionConfirmationDialog(false);
        setInvoiceModal(false);
        setRemarks("");
        props.setLoading(false);
        getFinanceRejectedInwardingData();
    }

    // Function to handle image change event
    const onImageChange = async (e) => {
        // Set loading state to false
        props.setLoading(false);

        // Get the file extension from the selected file
        const extension = e.target.files[0]?.name
            .split(".")
            .pop()
            .toLowerCase();

        const allowedExtensions = ["pdf", "jpg", "jpeg", "png"];
        // Check if the file extension is allowed
        if (!allowedExtensions.includes(extension)) {
            setNewInvoiceDetails({
                ...newInvoiceDetails,
                invoiceLink: "",
            });
            setFileUploaded(false);
            return props.setSnackInfo("Invalid file type. Please upload a pdf, jpg, jpeg, or png file.", "warning");
        }

        // Create a new FormData object
        const fd = new FormData();
        // Get the project code for the selected order ID
        let projectCode = procurementDetails?.projectId?.code;
        // Append the file to the FormData object with a custom name
        fd.append(
            "file",
            e.target.files[0],
            `${selectedOrderId}_${newInvoiceDetails.invoiceNumber}.${extension}`
        );
        // Append the customer name (project code) to the FormData object
        fd.append("customerName", projectCode);
        try {
            // Upload the file using the HttpService and get the response
            const fileUploadRes = await HttpService.uploadFile(fd);
            // Update the inwarding details with the uploaded file
            setNewInvoiceDetails({
                ...newInvoiceDetails,
                invoiceLink: fileUploadRes.data,
            });
            // Set the file upload state to true
            setFileUploaded(true);
        } catch (err) {
            // Handle any errors by displaying a snack bar message
            props.setSnackInfo(
                err?.response?.data ?? "Something went wrong",
                "error"
            );
        }

        // Set loading state to false
        props.setLoading(false);
    };

    // Function to close PO Modal
    const closePOModalHandler = () => {
        setInvoiceModal(false);
        setFreightCharge(0);
        setEditFields(false);
    }

    // Function to open Rejection Confirmation Dialog Box
    const rejectionConfirmationDialogOpenHandler = (status) => {
        setValue(status);
        setOpenRejectionConfirmationDialog(true);
    }

    // Function to make request to edit the PO 
    const sendPOEditRequestToProcurementManagerHandler = async (payload) => {
        props.setLoading(true);
        try {
            const response = await HttpService.sendPOEditRequestToProcurementManager(payload);
            props.setSnackInfo(response?.data?.msg ?? "Updated Successfully", response?.data?.type ?? "success");
        } catch (error) {
            console.error("Error -> ", error);
        }

        setInvoiceModal(false);
        props.setLoading(false);
        getFinanceRejectedInwardingData();
    }

    // Function to make the change request in "Procurement Order"
    const procurementOrderEditRequestHandler = async () => {
        try {
            setEditFields((state) => !state);
            if (editFields) {
                let payload = { inwardingDetails: details, gstDetails, freightCharge, procurementDetails };
                sendPOEditRequestToProcurementManagerHandler(payload);
            }
        } catch (error) {
            console.error("Error -> ", error);
        }
    }

    // Function to handle remarks input
    const remarksInputHandler = async (e) => {
        setRemarks(e.target.value);
        // if (e.target.value.trim() === "") return props.setSnackInfo("Please Enter Remarks", "error");
    };

    useEffect(() => {
        getFinanceRejectedInwardingData();
    }, []);

    return (
        <div>
            <div
                style={{
                    marginBottom: 20,
                    alignItems: "center",
                    justifyContent: "center",
                }}
            >
                <Paper className={classes.paper}>
                    <center>
                        <h2>Rejected Inwarding By Finance</h2>
                    </center>
                </Paper>
            </div>

            {/* Data Mapping of Rejected Inwarding By Finance */}
            <TableContainer component={Paper}>
                <Table
                    className={classes.table}
                    size="small"
                    aria-label="customized table"
                    stickyHeader
                >
                    <TableHead>
                        <TableRow>
                            <StyledTableCell>Sl No</StyledTableCell>
                            <StyledTableCell>Inwarding Id</StyledTableCell>
                            <StyledTableCell>PO No.</StyledTableCell>
                            {/* 
                            <StyledTableCell>Inwarded Date</StyledTableCell>
                            <StyledTableCell>Invoice Date</StyledTableCell>
                            <StyledTableCell>Invoice No.</StyledTableCell>
                            <StyledTableCell>PO Qty</StyledTableCell>
                            <StyledTableCell>Inwarded Qty</StyledTableCell>
                            <StyledTableCell>GST</StyledTableCell>
                            <StyledTableCell>Freight Charges</StyledTableCell>
                            <StyledTableCell>Total Value</StyledTableCell>
                            <StyledTableCell>Change In Rate</StyledTableCell>
                            <StyledTableCell>Change In GST</StyledTableCell> 
                            */}
                            <StyledTableCell>Rejection Reason</StyledTableCell>
                            <StyledTableCell>View</StyledTableCell>
                            <StyledTableCell>Status</StyledTableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {dataForPendingInwardingApproval?.map((el, i) => {
                            return (
                                <StyledTableRow key={i + 1}>
                                    <StyledTableCell>{i + 1}</StyledTableCell>
                                    <StyledTableCell>
                                        {el?.InwardingRecords?.inwardingId}
                                    </StyledTableCell>
                                    <StyledTableCell>
                                        {el?.procurementId?.orderId}
                                    </StyledTableCell>
                                    {/*
                                    <StyledTableCell>
                                        {moment(el?.InwardingRecords?.dateOfInwarded).format(
                                            "DD-MM-YYYY"
                                        )}
                                    </StyledTableCell>
                                    <StyledTableCell>
                                    {el?.InwardingRecords?.invoiceDate
                                        ? moment(el.InwardingRecords.invoiceDate).format("DD-MM-YYYY")
                                        : "N/A"}
                                    </StyledTableCell>
                                    <StyledTableCell>
                                        {el?.InwardingRecords?.invoiceNumber}
                                    </StyledTableCell>
                                    <StyledTableCell>
                                        {el?.bomQuantity?.toFixed(2)}
                                    </StyledTableCell>
                                    <StyledTableCell>{el?.InwardingRecords?.inwardedQty?.toFixed(2)}</StyledTableCell>
                                    <StyledTableCell>
                                        {el?.gstDetails[0]?.gstRate?.toFixed(2) || "N/A"}
                                    </StyledTableCell>
                                    <StyledTableCell>
                                        {el?.freightCharges?.toFixed(2) || "N/A"}
                                    </StyledTableCell>
                                    <StyledTableCell>{(+el?.InwardingRecords?.inwardedQty * +el?.InwardingRecords?.inwardedRate).toFixed(2)}</StyledTableCell>
                                    <StyledTableCell>{(+el?.materialIdOfInwarding?.pricePerUnit - +el?.InwardingRecords?.inwardedRate).toFixed(2)  || "N/A"}</StyledTableCell>
                                    <StyledTableCell>Test change in GST</StyledTableCell>
                                    */}
                                    <StyledTableCell>{el?.InwardingRecords?.remarks?.length > 0 ? el?.InwardingRecords?.remarks[el?.InwardingRecords?.remarks?.length - 1]?.msgBody : "N/A"}</StyledTableCell>
                                    <StyledTableCell>
                                        <>
                                            <EyeOutlined
                                                variant="contained"
                                                color="primary"
                                                style={{ color: "#1C375D" }}
                                                onClick={() => openInwardingDetailModalHandler(el)}
                                            />
                                            {/* </Button> */}
                                            {/* <Button variant="contained" color="primary" style={{ background: "#f50057", margin: 5 }} onClick={() => handleSubmit('Rejected', el)}>
                                                Reject
                                            </Button> */}
                                        </>
                                    </StyledTableCell>
                                    <StyledTableCell>{el?.InwardingRecords?.status}</StyledTableCell>
                                </StyledTableRow>
                            );
                        })}
                    </TableBody>
                </Table>
            </TableContainer>

            {/* PO Invoice Modal */}
            <Modal
                aria-labelledby="alert-dialog-slide-title"
                aria-describedby="alert-dialog-slide-description"
                title={`Rejected Inwarding | ${selectedOrderId}`}
                centered
                open={invoiceModal}
                onCancel={closePOModalHandler}
                width={1500}
                maskClosable={true}
                footer={null}
            >
                <div style={{ display: "flex", width: "100%" }}>
                    <div style={{ border: "1px solid #000", flex: 1, padding: "2px" }}>
                        <div
                            className="container"
                            style={{ width: "100%", marginTop: "2%" }}
                        >
                            <div>
                                <div>
                                    <table>
                                        <tbody>
                                            <tr>
                                                <td rowSpan="3" style={{ width: "50%" }}>
                                                    <div className="invoice">Invoice to:</div>
                                                    <div className="invoice-to">
                                                        <b>Samika Design Solutions Pvt Ltd.</b>
                                                        <div>
                                                            #17, 18th Cross Rd, Sector 3, HSR Layout,
                                                            Bengaluru - 560102
                                                        </div>
                                                        <div className="gstno">Gst No-29AAWCS3842H1ZO</div>
                                                        <div>State Name : Karnataka, Code : 29</div>
                                                        <div>E-Mail: sales@decorpot.com</div>
                                                    </div>
                                                </td>
                                                <td style={{ width: "25%" }}>
                                                    <div>Voucher No.</div>
                                                    <div className="vou-no">
                                                        <b>{procurementDetails?.orderId}</b>
                                                    </div>
                                                </td>
                                                <td style={{ width: "25%" }}>
                                                    <div>Dated:</div>
                                                    <div className="vou-no">
                                                        <b>
                                                            {moment(procurementDetails?.createdAt).format(
                                                                "DD-MM-YYYY"
                                                            )}
                                                        </b>
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td style={{ width: "25%" }}>&nbsp;</td>
                                                <td style={{ width: "25%" }}>
                                                    <div>Mode/Terms of Payment</div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td style={{ width: "25%" }}>
                                                    <div>Supplier's Ref./Order No.</div>
                                                    <div className="vou-no">
                                                        <b>{procurementDetails?.orderId}</b>
                                                    </div>
                                                </td>
                                                <td style={{ width: "25%" }}>
                                                    <div>Other Reference(s)/Comments</div>
                                                    <div className="vou-no">
                                                        <b>{procurementDetails?.comment}</b>
                                                    </div>
                                                </td>
                                            </tr>

                                            <tr>
                                                <td rowSpan="2" style={{ width: "50%" }}>
                                                    <div className="invoice">Supplier</div>
                                                    <div className="invoice-to">
                                                        <b>{procurementDetails?.vendorId?.name}</b>
                                                        <div>{procurementDetails?.vendorId?.address}</div>
                                                        <div className="row">
                                                            <div
                                                                className="col-md-2"
                                                                style={{ float: "left" }}
                                                            >
                                                                GSTIN/UIN
                                                            </div>
                                                            <div className="col-md-10">
                                                                :&nbsp;
                                                                {procurementDetails?.vendorId?.gstinNumber}
                                                            </div>
                                                            <div className="row">
                                                                <div
                                                                    className="col-md-2"
                                                                    style={{ float: "left" }}
                                                                >
                                                                    State Name
                                                                </div>
                                                                <div className="col-md-10">
                                                                    :&nbsp;Karnataka, Code : 29
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div>Inwarding Id</div>
                                                    <div className="vou-no">
                                                        <b>{details?.InwardingRecords?.inwardingId}</b>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div>Destination</div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td colSpan="1">
                                                    <div>Terms of Delivery</div>
                                                </td>
                                                <td style={{ width: "25%" }}>
                                                    <div>Invoice No.</div>
                                                    <div className="vou-no">
                                                        <b>{details?.InwardingRecords?.invoiceNumber}</b>
                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>

                                <div>
                                    <Table size="small" aria-label="custom pagination table">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell>Sl. No.</TableCell>
                                                <TableCell>Description of Goods</TableCell>
                                                <TableCell>Due On</TableCell>
                                                <TableCell>Inwarded Quantity</TableCell>
                                                {/* <TableCell>Inwarded Rate</TableCell> */}
                                                <TableCell>Rate</TableCell>
                                                <TableCell>per</TableCell>
                                                <TableCell>Disc. %</TableCell>
                                                <TableCell>Amount</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableHead>
                                            {procurementDetails?.materials?.map(
                                                (material, index) =>
                                                    material.isAdded && (
                                                        <TableRow key={index}>
                                                            <TableCell>{index + 1}</TableCell>
                                                            <TableCell>
                                                                <div>
                                                                    <b>{material?.materialId?.code}</b>
                                                                </div>
                                                                <br />
                                                                <div className="desc">
                                                                    [
                                                                    {material?.materialId?.aliasName
                                                                        ? material?.materialId?.aliasName
                                                                        : material?.materialId.name}
                                                                    ]
                                                                </div>
                                                                <br />
                                                                {material?.remark && (
                                                                    <div className="desc">{material?.remark}</div>
                                                                )}
                                                            </TableCell>
                                                            <TableCell>45 Days</TableCell>
                                                            <TableCell>
                                                                {details?.InwardingRecords?.inwardedQty}
                                                            </TableCell>
                                                            {/* 
                                                            <TableCell>
                                                                {details?.InwardingRecords?.inwardedRate}
                                                            </TableCell>
                                                            */}
                                                            <TableCell>
                                                                {!editFields ? details?.InwardingRecords?.inwardedRate :
                                                                    <FormControl style={{ width: 200 }}>
                                                                        <TextField
                                                                            style={{ margin: "5px" }}
                                                                            size="small"
                                                                            id={`requestedPrice-${index}`}
                                                                            label="Requested Price"
                                                                            value={details?.InwardingRecords?.inwardedRate}
                                                                            variant="outlined"
                                                                            name={`requestedPrice-${index}`}
                                                                            type="number"
                                                                            onChange={(e) =>
                                                                                materialPriceChangeHandler(index, e)
                                                                            }
                                                                        />
                                                                    </FormControl>
                                                                }
                                                            </TableCell>
                                                            <TableCell>{material?.unitId.name}</TableCell>
                                                            <TableCell>
                                                                {procurementDetails?.discount}
                                                            </TableCell>
                                                            {/* <TableCell >₹{material?.materialTotal?.toFixed(2)}</TableCell> */}
                                                            <TableCell>
                                                                ₹
                                                                {(
                                                                    material?.materialTotal?.toFixed(2) -
                                                                    (procurementDetails?.discount *
                                                                        material?.materialTotal) /
                                                                    100
                                                                ).toFixed(2)}
                                                            </TableCell>
                                                            {/* <TableCell>{(material?.materialTotal?.toFixed(2))} - {((procurementDetails?.discount * material?.materialTotal) / 100).toFixed(2)} = ₹{(material?.materialTotal?.toFixed(2) - (procurementDetails?.discount * material?.materialTotal) / 100).toFixed(2)}</TableCell> */}
                                                        </TableRow>
                                                    )
                                            )}
                                        </TableHead>
                                    </Table>
                                </div>

                                <div>
                                    <Table>
                                        <TableBody>
                                            <TableRow key="1">
                                                <TableCell>Total Qty</TableCell>
                                                <TableCell>{procurementDetails?.totalQty}</TableCell>
                                            </TableRow>
                                            {/*
                                            <TableRow key="2">
                                                <TableCell>
                                                    <i>Discount</i>
                                                </TableCell>
                                                <TableCell>{procurementDetails?.discount}%</TableCell>
                                            </TableRow>
                                            */}
                                            <TableRow key="2">
                                                <TableCell>
                                                    Freight Approved (W/O GST)
                                                </TableCell>
                                                <TableCell>₹{Math.round(procurementDetails?.totalFreightApproved ?? 0)}</TableCell>
                                            </TableRow>
                                            <TableRow key="3">
                                                <TableCell>
                                                    <i>Freight Charge</i>
                                                </TableCell>
                                                <TableCell>
                                                    {!editFields ? freightCharge :
                                                        <FormControl style={{ width: 300 }}>
                                                            <TextField
                                                                style={{ margin: "5px" }}
                                                                size="small"
                                                                id="outlined-basic"
                                                                label="Freight Charge"
                                                                value={freightCharge}
                                                                variant="outlined"
                                                                name="freight charge"
                                                                type="number"
                                                                onChange={(e) => freightChargeChangeHandler(e)}
                                                            />
                                                        </FormControl>
                                                    }
                                                </TableCell>
                                            </TableRow>
                                            <TableRow key="4">
                                                <TableCell>
                                                    <i>GST Rate</i>
                                                </TableCell>
                                                <TableCell>
                                                    {!editFields ? procurementDetails?.gstDetails ? (procurementDetails.gstDetails.length !== 0 ? (procurementDetails.gstDetails[0].rate ? procurementDetails.gstDetails[0].rate : 'N/A') : 'N/A') : "N/A" :
                                                        // <FormControl style={{ width: 300 }}>
                                                        //     <TextField
                                                        //         style={{ margin: "5px" }}
                                                        //         size="small"
                                                        //         id="outlined-basic"
                                                        //         label="GST Rates"
                                                        //         // value={transportationCharge}
                                                        //         variant="outlined"
                                                        //         name="Transportation Charge"
                                                        //         type="number"
                                                        //         // onChange={(e) =>
                                                        //         //     transportationChargesChangeHandler(e)
                                                        //         // }
                                                        //     />
                                                        // </FormControl>
                                                        <Autocomplete
                                                            value={gstDetails?.rate}
                                                            onChange={(e, value) => gstRateChangeHandler(e, value)}
                                                            id="percent"
                                                            options={gstPercent}
                                                            getOptionLabel={(option) => `${option}%`}
                                                            style={{ width: '48%' }}
                                                            renderInput={(params) => <TextField {...params} label="Select GST percent" fullWidth variant="outlined" />}
                                                        />
                                                    }
                                                    {/* {procurementDetails?.gstDetails ? (procurementDetails.gstDetails.length !== 0 ? (procurementDetails.gstDetails[0].rate ? procurementDetails.gstDetails[0].rate : 'N/A') : 'N/A') : "N/A"}% */}
                                                </TableCell>
                                            </TableRow>
                                            <TableRow key="5">
                                                <TableCell>
                                                    <i>Gst Charge</i>
                                                </TableCell>
                                                <TableCell>
                                                    {/* <FormControl style={{ width: 300 }}>
                                                        <TextField
                                                            style={{ margin: "5px" }}
                                                            size="small"
                                                            id="outlined-basic"
                                                            label="Gst Charge"
                                                            value={gstAmounts}
                                                            variant="outlined"
                                                            name="Gst Charge"
                                                            type="number"
                                                            onChange={(e) => gstChangeHandler(e)}
                                                        />
                                                    </FormControl> */}
                                                    {gstAmounts}
                                                </TableCell>
                                            </TableRow>
                                            <TableRow key="6">
                                                <TableCell>Total Amount</TableCell>
                                                <TableCell>
                                                    {/* ₹{Math.round(procurementDetails?.grandTotal)} */}
                                                    ₹{procurementDetails?.grandTotal?.toFixed(2)}
                                                </TableCell>
                                            </TableRow>
                                        </TableBody>
                                    </Table>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div style={{ border: "1px solid #000", flex: 1, padding: "" }}>
                        {
                            // Display pdf when file type is pdf
                            getFileType(details?.InwardingRecords?.invoice) === "pdf" ? (
                                <iframe
                                    title="PDF Viewer"
                                    src={`https://docs.google.com/gview?url=${details?.InwardingRecords?.invoice}&embedded=true`}
                                    style={{
                                        width: "fit-content",
                                        height: "800px",
                                        border: "none",
                                    }}
                                ></iframe>
                            ) : // Display image when file is image
                                getFileType(details?.InwardingRecords?.invoice) === "image" ? (
                                    <img
                                        src={details?.InwardingRecords?.invoice}
                                        width="100%"
                                        alt="Image"
                                    ></img>
                                ) : (
                                    // Display warning when file type is not supported
                                    <p style={{ color: "red", padding: "10%" }}>
                                        <b>File Format Not Supported</b>
                                    </p>
                                )
                        }
                    </div>
                </div>

                <DialogActions>
                    {!editFields && <Button
                        onClick={() => rejectionConfirmationDialogOpenHandler("Rejected")}
                        color="secondary"
                        variant="outlined"
                    >
                        Reject
                    </Button>}
                    <Button
                        onClick={() => procurementOrderEditRequestHandler()}
                        color="secondary"
                        variant="outlined"
                    >
                        {editFields ? "Submit Request" : "Edit"}
                    </Button>
                    {!editFields && <Button
                        onClick={() => openResolveModalHandler("Resolved")}
                        color="primary"
                        variant="contained"
                        style={{ background: "#2b7636", margin: 5 }}
                    >
                        Resolve
                    </Button>}
                </DialogActions>
            </Modal>

            {/* New Invoice Dialog Box  */}
            <div>
                <Dialog
                    open={openRemarksModal}
                    onClose={closeNewInvoiceDetailsModalHandler}
                    aria-labelledby="form-dialog-title"
                    maxWidth="sm"
                    fullWidth
                >
                    <DialogContent>
                        <DialogContentText>Enter New Invoice Details</DialogContentText>
                        <TextField
                            id="new-invoice-number"
                            name="new-invoice-number"
                            label="New Invoice Number"
                            variant="outlined"
                            type="text"
                            value={newInvoiceDetails.invoiceNumber}
                            onChange={newInvoiceDetailsHandler}
                            fullWidth
                        /><hr></hr>
                        <TextField
                            id="new-invoice-date"
                            name="new-invoice-date"
                            label="New Invoice Date"
                            variant="outlined"
                            type="date"
                            value={newInvoiceDetails.invoiceDate}
                            onChange={newInvoiceDetailsHandler}
                            InputLabelProps={{
                                shrink: true,
                            }}
                            inputProps={{
                                max: new Date().toISOString().split('T')[0],
                            }}
                            fullWidth
                        /><hr></hr>
                        <TextField
                            id="remarks"
                            name="remarks"
                            label="Add Remarks"
                            variant="outlined"
                            type="text"
                            value={newInvoiceDetails.remarks}
                            onChange={newInvoiceDetailsHandler}
                            fullWidth
                        />
                        <hr></hr>
                        <div>
                            <div style={{ marginTop: "30px", marginBottom: "20px" }}>
                                <input
                                    accept="*"
                                    className={classes.input}
                                    id="contained-button-file"
                                    multiple
                                    type="file"
                                    onChange={onImageChange}
                                    style={{ display: 'none' }}
                                    name="PaymentSlip"
                                />
                            </div>
                            <div>
                                <label htmlFor="contained-button-file">
                                    <Button variant="contained" color="primary"
                                        component="span" startIcon={<CloudUploadIcon />}>
                                        Upload New Invoice
                                    </Button>
                                    {
                                        fileUploaded && <CheckCircleIcon style={{ verticalAlign: 'middle', marginLeft: 10, color: "green", fontSize: 30 }} />
                                    }
                                </label>
                            </div>
                        </div>
                    </DialogContent>
                    <DialogActions>
                        <Button
                            variant="outlined"
                            onClick={closeNewInvoiceDetailsModalHandler}
                            color="secondary"
                        >
                            Cancel
                        </Button>
                        <Button
                            onClick={resolveRejectedInwardingHandler}
                            variant="contained"
                            color="primary"
                            disabled={(!fileUploaded || newInvoiceDetails.invoiceNumber === "" || newInvoiceDetails.invoiceDate === "" || newInvoiceDetails.invoiceLink === "" || newInvoiceDetails.remarks === "")}
                            style={{ background: "#2b7636", margin: 5 }}
                        >
                            Submit
                        </Button>
                    </DialogActions>
                </Dialog>
            </div>

            {/* Rejection Dialog Box  */}
            <div>
                <Dialog
                    open={openRejectionConfirmationDialog}
                    onClose={() => { setOpenRejectionConfirmationDialog(false) }}
                    aria-labelledby="form-dialog-title"
                    maxWidth="sm"
                    fullWidth
                >
                    <DialogContent>
                        <DialogContentText style={{ color: "red", fontWeight: "bold" }}>
                            Please confirm your rejection. This action will reject the inwarding and reduce the factory stock. (A Cancelled GRN will be Generated)
                        </DialogContentText>
                        <TextField
                            id="remarks"
                            name="Remarks"
                            label="Add Remarks"
                            variant="outlined"
                            type="text"
                            value={remarks}
                            onChange={remarksInputHandler}
                            fullWidth
                        />
                    </DialogContent>
                    <DialogActions>
                        <Button
                            variant="outlined"
                            onClick={() => { setOpenRejectionConfirmationDialog(false) }}
                            color="secondary"
                        >
                            Cancel
                        </Button>
                        <Button
                            onClick={rejectInwardingFromFactory}
                            variant="contained"
                            color="primary"
                            style={{ background: "#2b7636", margin: 5 }}
                        >
                            Confirm
                        </Button>
                    </DialogActions>
                </Dialog>
            </div>
        </div>
    );
};

export default connect(null, { setLoading, setSnackInfo })(
    RejectedInwarding
);